/**
 * User-facing copy.
 *
 * Centralised so the same failure reads the same way everywhere, and so
 * translating later means editing one file rather than hunting strings through
 * components.
 */
export const ERRORS = {
  generic: 'Something went wrong. Please try again.',
  network: 'Could not reach the server. Check your connection and try again.',
  unauthorized: 'Your session has ended. Please sign in again.',
  forbidden: 'You do not have access to that.',
  notFound: 'We could not find what you were looking for.',
  rateLimited: 'Too many attempts. Please wait a moment and try again.',
  invalidCredentials: 'That email or password is not correct.',
  accountLocked: 'This account is locked. Please contact your administrator.',
  mfaInvalid: 'That code is not correct. Check your authenticator app and try again.',
  /**
   * Distinct from mfaInvalid on purpose: a wrong code invites another attempt,
   * but an expired challenge means there is nothing left to retry against and
   * the password has to be entered again.
   */
  mfaExpired: 'This sign-in took too long. Please enter your password again.',
} as const;

export const SUCCESS = {
  signedIn: 'Signed in.',
  signedOut: 'Signed out.',
  saved: 'Saved.',
} as const;

export const LABELS = {
  signIn: 'Sign in',
  signOut: 'Sign out',
  email: 'Email',
  password: 'Password',
  loading: 'Loading',
} as const;
